import React, {Component} from 'react'
import './FooterComponent.css'

import TempoLiberoLogoSimple from '../assets/tempolibero_logo_simple.png'
import EmpoliLogo from '../assets/LogoEmpoli.png'

// import LogoLine from '../assets/logo_line.png'
import MessaggioLogo from '../assets/Oggetto-message.png'

export default class FooterComponent extends Component {
    render() {
        return(
            <footer className="text-center">
                <div className="footer-above">
                    <div className="container">
                        <div className="row">
                            {/*TELEFONO*/}
                            <div className="hidden-sm hidden-md hidden-lg visible-xs">
                                <div className="footer-col col-xs-12" style={{marginTop: 17, display: 'flex', justifyContent: 'flex-end'}}>
                                    <div className="footer-logo-col col-xs-2" style={{marginBottom: 17}}>
                                        <a href="mailto:empoli@tempolibero.city" className="footer-btn-1"><img className="logo-message-logo" src={MessaggioLogo} /></a>
                                    </div>
                                    {/* <div className="footer-logo-col col-xs-6" style={{marginLeft: 8}}>
                                        <a href="#" className="footer-btn-2"><span>0371.412542</span></a>
                                    </div> */}
                                </div>
                                <div className="footer-col col-xs-12"  style={{paddingLeft: 0}}>
                                    <div className="footer-logo-col col-xs-4">
                                        <a href="#" className="btn-social btn-outline logo-footer"><img className="logo-peroT" src={TempoLiberoLogoSimple} /></a>
                                    </div>
                                    <div className="footer-logo-col col-xs-4">
                                        <a href="#" className="btn-social btn-outline logo-footer-peroC"><img className="logo-peroC" src={EmpoliLogo} /></a>
                                    </div>
                                    {/* <div className="footer-logo-col col-xs-4" style={{paddingTop: 0}}>
                                        <a href="https://www.lineservizi.it" className="btn-social btn-outline logo-footer-line"><img className="logo-logoLine" src={LogoLine} /></a>
                                    </div> */}
                                </div>
                            </div>

                            {/*TABLET*/}
                            <div className="visible-sm hidden-md hidden-lg hidden-xl">
                                <div className="footer-col col-sm-6">
                                    <div className="footer-logo-col col-sm-6">
                                        <a href="#" className="btn-social btn-outline logo-footer"><img className="logo-peroT" src={TempoLiberoLogoSimple} /></a>
                                    </div>
                                    <div className="footer-logo-col col-sm-6">
                                        <a href="#" className="btn-social btn-outline logo-footer-peroC"><img className="logo-peroC" src={EmpoliLogo} /></a>
                                    </div>
                                    {/* <div className="footer-logo-col col-sm-4" style={{paddingTop: 0}}>
                                        <a href="https://www.lineservizi.it" className="btn-social btn-outline logo-footer-line"><img className="logo-logoLine" src={LogoLine} /></a>
                                    </div> */}
                                </div>
                                <div className="footer-col col-sm-6" style={{marginTop: 17, display: 'flex', justifyContent: 'flex-end'}}>
                                    <div className="footer-logo-col col-sm-2 col-sm-offset-2">
                                        <a href="mailto:empoli@tempolibero.city" className="footer-btn-1"><img className="logo-message-logo" src={MessaggioLogo} /></a>
                                    </div>
                                    {/* <div className="footer-logo-col col-sm-6 col-sm-offset-1" style={{marginLeft: 8}}>
                                        <a href="#" className="footer-btn-2"><span>0371.412542</span></a>
                                    </div> */}
                                </div>
                            </div>

                            {/*SCHERMO*/}
                            <div className="hidden-sm hidden-md visible-lg hidden-xl">
                                <div className="footer-col col-md-6">
                                    <div className="footer-logo-col col-md-6">
                                    <a href="#" className="btn-social btn-outline logo-footer"><img className="logo-peroT" src={TempoLiberoLogoSimple} /></a>
                                    </div>
                                    <div className="footer-logo-col col-md-6">
                                        <a href="#" className="btn-social btn-outline logo-footer-peroC"><img className="logo-peroC" src={EmpoliLogo} /></a>
                                    </div>
                                    {/* <div className="footer-logo-col col-md-4" style={{paddingTop: 0}}>
                                        <a href="https://www.lineservizi.it" className="btn-social btn-outline logo-footer-line"><img className="logo-logoLine" src={LogoLine} /></a>
                                    </div> */}
                                </div>
                                <div className="footer-col col-md-3 col-md-offset-2" style={{marginTop: 17, display: 'flex', justifyContent: 'flex-end'}}>
                                    <div className="footer-logo-col col-md-2">
                                        <a href="mailto:empoli@tempolibero.city" className="footer-btn-1"><img className="logo-message-logo" src={MessaggioLogo} /></a>
                                    </div>
                                    {/* <div className="footer-logo-col col-md-6 col-md-offset-1" style={{marginLeft: 8}}>
                                        <a href="#" className="footer-btn-2"><span>0371.412542</span></a>
                                    </div> */}
                                </div>
                            </div>

                            <div className="hidden-sm visible-md hidden-lg hidden-xl">
                                <div className="footer-col col-md-6">
                                    <div className="footer-logo-col col-md-6">
                                        <a href="#" className="btn-social btn-outline logo-footer"><img className="logo-peroT" src={TempoLiberoLogoSimple} /></a>
                                    </div>
                                    <div className="footer-logo-col col-md-6">
                                        <a href="#" className="btn-social btn-outline logo-footer-peroC"><img className="logo-peroC" src={EmpoliLogo} /></a>
                                    </div>
                                    {/* <div className="footer-logo-col col-md-4" style={{paddingTop: 0}}>
                                        <a href="https://www.lineservizi.it" className="btn-social btn-outline logo-footer-line"><img className="logo-logoLine" src={LogoLine} /></a>
                                    </div> */}
                                </div>
                                <div className="footer-col col-md-4 col-md-offset-1" style={{marginTop: 17, display: 'flex', justifyContent: 'flex-end'}}>
                                    <div className="footer-logo-col col-md-2">
                                        <a href="mailto:empoli@tempolibero.city" className="footer-btn-1"><img className="logo-message-logo" src={MessaggioLogo} /></a>
                                    </div>
                                    {/* <div className="footer-logo-col col-md-6 col-md-offset-1" style={{marginLeft: 8}}>
                                        <a href="#" className="footer-btn-2"><span>0371.412542</span></a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>


        );
    }
}



// WEBPACK FOOTER //
// ./src/components/FooterComponent.js